fragment haftarahMelodyDetails on HaftarahMelodyType {
  id
  description
}
